import { Component, OnInit, inject } from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {NgOptimizedImage} from "@angular/common";
import {HeaderComponent} from "../../../common/header/header.component";
import {NavigationEnd, Router, RouterLink} from "@angular/router";
import {LocaleService} from "../../../../locale/locale.service";
import {FinishBoxComponent} from "../../../common/finish-box/finish-box.component";
import { ColoredBackgroundComponent } from '../../../common/colored-background/colored-background.component';

@Component({
  selector: 'app-claim-report-duty-information',
  imports: [
    ColoredBackgroundComponent,
    FooterComponent,
    HeaderComponent,
    RouterLink,
    FinishBoxComponent
  ],
  templateUrl: './claim-report-duty-information.component.html',
  styleUrl: './claim-report-duty-information.component.css'
})
export class ClaimReportDutyInformationComponent implements OnInit {
  private router = inject(Router);
  locale = inject(LocaleService);


  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }
}
